import {
  showImport,
  editImport,
  createImport,
  storeImport,
  updateImport,
  getImportTableData,
  findCustomerByEmail,
  getProductOptions,
  getVarietyOptions,
} from '@app/api/import.api';
import { createInitialFollowUp, storeFollowUp } from '@app/api/follow-up.api';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { notificationController } from '@app/controllers/notificationController';
import { ImportRequest } from '@app/models/import/ImportRequest';
import { Form, notification, Tabs, Input, Select, message, Modal } from 'antd';
import { Tab } from 'rc-tabs/lib/interface';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ImportInfo from './ImportInfo';
import CommentsTab from '../common/import/Comments';
import AdditionalInfo from './AdditionalInfo';
import { DropdownOption } from '@app/models/DropdownOption';
import { authUserService } from '@app/services/authUser.service';
import { getVerifiedCustomers } from '@app/api/customer.api';
import { Customer } from '@app/models/customer/Customer';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { useTranslation } from 'react-i18next';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { CustomerInfoForm } from '@app/components/forms/CustomerInfoForm/CustomerInfoForm';
import StatusBar from '@app/components/statusBar/statusBar';
import { CustomerDTO } from '@app/models/customer/CustomerDTO';
import DocumentChecklist from './DocumentCheckList';
import PackingList from './PackingList';
import ShipmentArrivals from './ShipmentArrivals';
import AdditionalDocument from './AdditionalDocument';
import PaymentsInfo from './PaymentsInfo';
import FollowUpsTable from './FollowUpTable';
import dayjs from 'dayjs';

const { Search } = Input;

interface TypeOfForm {
  type: 'edit' | 'create' | 'view';
}

interface ImportFormProps extends TypeOfForm {
  editable: boolean;
  id?: string;
  showEditIcon?: boolean;
  pageTitle: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  setCurrentBreadcrumName: Function;
}

const ImportForm: React.FC<ImportFormProps> = ({ editable = false, id, pageTitle, type, setCurrentBreadcrumName }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [status, setStatus] = useState<string | null>(null);
  const navigate = useNavigate();
  const importId = parseInt(id ?? '');
  const [referenceCode, setReferenceCode] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [comments, setComments] = useState([]);
  const [customerId, setCustomerId] = useState<number | null>(null);
  const [productCategories, setProductCategories] = useState<DropdownOption[]>([]);
  const [products, setProducts] = useState<string[]>([]);
  const [location_options, setLocationOptions] = useState<DropdownOption[]>([]);
  const [department_options, setDepartmentOptions] = useState<DropdownOption[]>([]);
  const [countries, setCountries] = useState<DropdownOption[]>([]);
  const [prOptions, setPrOptions] = useState<DropdownOption[]>([]);
  const [pcOptions, setPcOptions] = useState<DropdownOption[]>([]);
  const [fetchedCustomerID, setFetchedCustomerID] = useState<number | null>(null);
  const [acceptedFields, setAccepetedFields] = useState([]);
  const user = authUserService.getUser();
  const { t } = useTranslation();
  const [wfActions, setWfActions] = useState<string[]>([]);
  const { addHeaderButton, removeHeaderButton } = useHeader();
  const [DocFormFields, setDocFormFields] = useState<any[]>([]);
  const [IniDocFormFields, setIniDocFormFields] = useState<any[]>([]);
  const [IniImportLinesDocFormFields, setIniImportLinesDocFormFields] = useState<any[]>([]);
  const [ImportLinesVariieties, setIniImportLinesVariieties] = useState<any[]>([]);
  const [Arrivals, setIniArrivals] = useState<any[]>([]);
  const [ProductOptions, setProductOptions] = useState<any[]>([]);
  const [ImportLines, setImportLines] = useState<any[]>([]);
  const [submittedDocs, setSubmittedDocs] = useState<any[]>([]);
  const [additionalSubmittedDocs, setadditionalSubmittedDocs] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string>('1');
  const [editableUserType, setEditableUserType] = useState<any[]>([]);
  const [editInfo, setEditInfo] = useState<any[]>([]);
  const [uploadAdditional, setUploadAdditional] = useState<any[]>([]);
  const [editArrival, setEditArrival] = useState<any[]>([]);
  const [ArrivalProducts, setArrivalProduct] = useState<any[]>([]);
  const [AllowedWeightage, setAllowedWeightage] = useState<any | null>(null);
  const [ImportedWeightage, setImportedWeightage] = useState<any | null>(null);
  const [importDetails, setimporteDetails] = useState({
    job_id: '',
    job_type: '',
    status: '',
    Expiration_Countdown: '',
  });
  const [customerData, setCustomerInfo] = useState<CustomerDTO | null>(null);
  const [customerSearchable, setCustomerSearchable] = useState(false);
  const [invoiceData, setInvoiceData] = useState<any[]>([]);
  const [serviceCharges, setServiceCharges] = useState<any[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState<DropdownOption | null>(null);
  const [importd, setImportd] = useState<any>(null);
  const [canCreateFollowUp, setCanCreateFollowUp] = useState<any | null>(null);

  const importTypee = localStorage.getItem('selected_import_type') || 'NORMAL';

  const [followUpModalVisible, setFollowUpModalVisible] = useState(false);
  const [selectedArrival, setSelectedArrival] = useState<any>(null);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [arrivalProductOptions, setArrivalProductOptions] = useState<any[]>([]);
  const [followUpLoading, setFollowUpLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [selectedVariety, setSelectedVariety] = useState<any[]>([]);
  const [varietyOptions, setVarietyOptions] = useState<any[]>([]);
  const [varietyLoading, setVarietyLoading] = useState(false);

  const [importPackingListLines, setImportPackingListLines] = useState<any[]>([]);
  const importPackingListLinesRef = useRef<any[]>([]);

  const updateImportPackingListLines = (lines: any[]) => {
    setImportPackingListLines(lines);
    importPackingListLinesRef.current = lines;
  };

  const items: Tab[] | undefined = [
    {
      key: '1',
      label: 'Customer Info',
      children: (
        <CustomerInfoForm
          form={form}
          type={type}
          customerInfo={customerData}
          importTypee={importTypee}
          createType={null}
          key={importTypee}
          // email={customerEmail}
          // status={customerStatus}
          onPrOptionsChange={setPrOptions}
          onPcOptionsChange={setPcOptions}
          onEmailSearch={(customerID) => setFetchedCustomerID(customerID)}
        />
      ),
    },
    {
      key: '2',
      label: 'Consigment Info',
      children: (
        <ImportInfo
          editable={editable}
          editableUser={editableUserType}
          acceptedFields={acceptedFields}
          setAcceptedFields={setAccepetedFields}
          productCategories={productCategories}
          country_options={countries}
          location_options={location_options}
          prOptions={prOptions}
          importStatus={status}
          pcOptions={pcOptions}
          department_options={department_options}
          form={form}
          importData={undefined}
        />
      ),
    },

    ...(user?.id !== 4 && status !== null && status !== 'DRAFT'
      ? [
          {
            key: '3',
            label: 'Additional Info',
            children: (
              <AdditionalInfo
                editInfo={editInfo}
                importStatus={status}
                serviceCharges={serviceCharges}
                import_id={id ?? ''}
                department={selectedDepartment}
                form={form}
                importData={importd}
              />
            ),
          },
        ]
      : []),
    ...(status !== null && status !== 'DRAFT' && importTypee === 'NORMAL'
      ? [
          {
            key: '4',
            label: t('Document Checklist'),
            children: (
              <DocumentChecklist
                initialformFields={IniDocFormFields}
                initialImportLinesDocFormFields={IniImportLinesDocFormFields}
                submittedDocs={submittedDocs}
                formFields={DocFormFields}
                status={status ?? ''}
                import_id={id ?? ''}
                //editable={editable}
                importData={undefined}
                productNames={products}
              />
            ),
          },
        ]
      : []),
    ...(status !== null && status !== 'DRAFT'
      ? //&&
        // status !== 'PENDING_DOCUMENT' &&
        // status !== 'PENDING_DG' &&
        // status !== 'PENDING_VERIFICATION_AQO' &&
        // status !== 'PENDING_CUSTOMER_VISIT' &&
        // status !== 'PENDING_PAYMENT' &&
        // status !== 'PENDING_VISIT'
        [
          {
            key: '5',
            label: t('Additional Documents'),
            children: (
              <AdditionalDocument
                import_id={id ?? ''}
                editable={editable}
                uploadAdditional={uploadAdditional}
                additionalSubmittedDocs={additionalSubmittedDocs}
                status={status}
              />
            ),
          },
        ]
      : []),
    ...(status !== null && status !== 'DRAFT'
      ? [
          {
            key: '6',
            label: t('Packing List'),
            children: (
              <PackingList
                import_id={id ?? null}
                editable={editable}
                editableUser={editableUserType}
                importStatus={status}
                onPackingListChange={updateImportPackingListLines}
              />
            ),
          },
        ]
      : []),
    ...(user?.id !== 4 && status !== null && status !== 'DRAFT' && status !== 'PENDING_DOCUMENT'
      ? [
          {
            key: '7',
            label: t('Shipment Arrivals'),
            children: (
              <ShipmentArrivals
                import_id={id ?? null}
                editArrival={editArrival}
                importLinesVarieties={ImportLinesVariieties}
                arrivals={Arrivals}
                status={status}
                ArrivalProducts={ArrivalProducts}
                AllowedWeightage={AllowedWeightage}
                ImportedWeightage={ImportedWeightage}
              />
            ),
          },
        ]
      : []),
    ...(status !== null &&
    status !== 'DRAFT' &&
    status !== 'PENDING_DOCUMENT' &&
    status !== 'PENDING_DG_APPROVAL' &&
    status !== 'PENDING_VERIFICATION_AQO' &&
    status !== 'PENDING_CUSTOMER_VISIT'
      ? [
          {
            key: '8',
            label: t('Payments Info'),
            children: (
              <PaymentsInfo
                id={id ?? null}
                pr_code={code}
                invoice_data={invoiceData}
                ImpStatus={status}
                wfActions={wfActions || []}
              />
            ),
          },
        ]
      : []),
    ...(status !== null && status == 'COMPLETED'
      ? [
          {
            key: '9',
            label: t('Follow Up'),
            children: <FollowUpsTable import_id={importId || null} editable={editable} status={status} />,
          },
        ]
      : []),
    ...(type !== 'create' && status !== null && status !== 'DRAFT'
      ? [
          {
            key: '10',
            label: t('Comments'),
            children: <CommentsTab editable={editable} status={status} commentData={comments} import_id={id ?? null} />,
          },
        ]
      : []),
  ];

  function setCustomerData(customer: Customer | undefined) {
    if (!customer) return;

    const customerId = JSON.parse(localStorage.getItem('user') || '{}')?.customer?.id ?? '';

    form.setFieldsValue({
      id: customerId,
      email: customer.user?.email || '',
      name: customer.name || `${customer.first_name || ''} ${customer.last_name || ''}`.trim(),
      status: customer.user?.status || '',
      customer_type: customer.customer_type || '',
      contact_no: customer.contact_no || '',
      address: customer.address || '',
      nic: customer.nic || '',
      dob: customer.dob || '',
    });
  }

  // useEffect(() => {
  //   async function fetchImportData() {
  //     try {
  //       const importData = await editImport(Number(id));
  //       console.log('Full editImport data:', importData);

  //       if (importData?.customer) {
  //         const customer = importData.customer;
  //         console.log('Customer Data:', customer);
  //         settCustomerData(customer);

  //         // Extract email & status from customer.user (if available)
  //         if (customer.user) {
  //           setCustomerEmail(customer.user.email);
  //           setCustomerStatus(customer.user.status);
  //           console.log('Customer Email:', customer.user.email);
  //           console.log('Customer Status:', customer.user.status);
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Error fetching import data:', error);
  //     }
  //   }

  //   fetchImportData();
  // }, [editImport, id]);

  const setApiData = (res: any) => {
    const referenceCode = res?.import?.code ?? 'New';
    const breadcrumbName = `${referenceCode}`;
    setCurrentBreadcrumName(breadcrumbName);
    setCode(res?.import?.code ?? 'N/A');
    setReferenceCode(res?.import?.reference_code ?? 'N/A');
    setStatus(res?.import?.status ?? 'New');
    setAccepetedFields(res?.import?.accepted);
    setProductCategories(res?.pr_category_options);
    setCountries(res?.country_options);
    setEditableUserType(res?.import?.editable_for_usertype);
    setEditInfo(res?.import?.editable_info);
    setEditArrival(res?.import?.editable_arrival);
    setUploadAdditional(res?.import?.can_upload_additional);
    //setPrOptions(res?.pr_options ?? []);
    //setPcOptions(res?.pc_options ?? []);
    setPrOptions(res?.pr_options ?? []);
    setPcOptions(res?.pc_options ?? []);
    setComments(res?.import?.import_comments ?? []);
    setLocationOptions(res?.location_options ?? []);
    setDepartmentOptions(res?.department_options ?? []);
    setWfActions(res?.wf_actions ?? []);
    setCustomerId(res?.import?.customer?.id);
    setIniDocFormFields(Object.values(res?.import?.product_category?.import_document_collections ?? []));
    setIniImportLinesDocFormFields(
      res?.import?.import_lines
        ?.map((line: { product: { import_document_collections: any } }) => line.product?.import_document_collections)
        ?.flat() ?? [],
    );
    setInvoiceData(res?.import?.invoices ?? []);
    setCustomerData(res?.import?.customer ?? []);
    setCustomerInfo(res?.import?.customer ?? null);
    setServiceCharges(res.service_charge_options ?? []);

    setIniImportLinesVariieties(res?.import?.import_lines ?? []);
    setIniArrivals(res?.import?.arrivals ?? []);
    setProductOptions(res?.product_options ?? []);
    setImportLines(res?.import?.import_lines ?? []);
    const existingLines =
      res?.import?.import_lines?.map((line: any) => ({
        id: line.id ?? null,
        product_id: line.product_id,
        quantity: line.quantity,
        import_line_varieties:
          line.import_line_varieties?.map((v: any) => ({
            id: v.id ?? null,
            product_variety_id: v.product_variety_id,
            L4: {
              species: v.L4?.species ?? '',
              brand_names: v.L4?.brand_names ?? '',
            },
            quantity: v.quantity,
          })) ?? [],
      })) ?? [];
    importPackingListLinesRef.current = existingLines;
    setImportPackingListLines(existingLines);
    setSubmittedDocs(res?.import?.import_documents ?? []);
    setadditionalSubmittedDocs(res?.import?.import_additional_documents ?? []);
    setProducts(res?.import?.importlines?.map((line: { product: { name: any } }) => line.product?.name) ?? []);
    setCustomerSearchable(res.customer_searchable ?? 'N/A');

    setDocFormFields(res.pre_clearance?.product_category || []);
    setSelectedDepartment(res?.import?.department ?? null);
    setImportd(res?.import ?? null);

    setimporteDetails({
      job_id: res?.import?.id ?? 'N/A',
      job_type: res?.import?.product_reg_type ?? 'N/A',
      Expiration_Countdown: res?.import?.expire_date ?? 'N/A',
      status: res?.import?.status ?? '',
    });
    setArrivalProduct(
      res?.import?.import_lines?.map((line: any) => ({
        id: line.product.id,
        label: `${line.product.code} - ${line.product.name}`,
      })) ?? [],
    );
    setAllowedWeightage(res?.import?.allowed_weightage ?? 0);
    setImportedWeightage(res?.import?.imported_weightage ?? 0);
    setCanCreateFollowUp(res?.import?.can_create_follow_up ?? false);

    if (res?.import?.customer) {
      setCustomerData(res.import.customer);
    }

    form.setFieldsValue({
      code: referenceCode,
      status: res?.import?.status,
      location_id: res?.import?.location_id,
      department_id: res?.import?.department_id,
      product_category_id: res?.import?.product_category_id,
      product_category: res?.import?.product_category,
      customer_id: customerId,
      accepted: acceptedFields,
      country_ids: res?.import?.countries?.map((e: any) => e?.id) ?? [],
      quantity: res?.import?.quantity,
      consignment_status: res?.import?.consignment_status,
      allowed_weightage: res?.import?.allowed_weightage,
      approval_id: res?.import?.approval_id,
      expire_date: res?.import?.expire_date,
      product_reg_type: res?.import?.product_reg_type,
      type: res?.import?.type,
      site_visit: res?.import?.site_visit,
      custom_deck_no: res?.import?.custom_deck_no,
      container_type: res?.import?.container_type,
      sample_count: res?.import?.sample_count,
      pr_registration_ids: res?.import?.product_registrations?.map((e: any) => e?.id) ?? [],
      pre_clearances_ids: res?.import?.pre_clearances?.map((e: any) => e?.id) ?? [],
    });
  };

  useEffect(() => {
    setLoading(true);
    if (importId) {
      if (type === 'view') {
        showImport(importId)
          .then((res: any) => {
            setApiData(res);
            setLoading(false);
          })
          .catch((err: any) => {
            setLoading(false);
            notification.error({ message: 'Failed to Import', description: err.message });
            console.error(err);
          });
      } else if (type === 'edit') {
        editImport(importId)
          .then((res: any) => {
            setApiData(res);
            setLoading(false);
          })
          .catch((err: any) => {
            setLoading(false);
            notification.error({ message: 'Failed to edit Import', description: err.message });
            console.error(err);
          });
      }
    } else if (type === 'create') {
      createImport()
        .then((res: any) => {
          setApiData(res);
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          notification.error({ message: 'Failed to fetch all Import', description: err.message });
          console.error(err);
        });
    }
  }, [importId, status]);

  const handleSubmit = (values: ImportRequest) => {
    const data = form.getFieldsValue();
    const finalCustomerId = customerId ?? fetchedCustomerID ?? user?.customer?.id ?? null;
    console.log({
      customerId,
      fetchedCustomerID,
      localCustomerId: user?.customer?.id,
    });

    if (editable) {
      const departmentId = form.getFieldValue('department_id') || null;
      const submissionData = {
        ...data,
        ...values,
        customer_id: finalCustomerId,
        department_id: departmentId,
        accepted: acceptedFields ?? [],
        expires_at: form.getFieldValue('expires_at') || '',
        location_id: form.getFieldValue('location_id') || null,
        product_category_id: form.getFieldValue('product_category_id') || null,
        //product_reg_typ: form.getFieldValue('product_reg_typ') || '',
        expire_date: form.getFieldValue('expire_date') || '',
        approval_id: form.getFieldValue('approval_ids') || null,
        total_quantity: form.getFieldValue('total_quantity') || 0,
        consignment_status: form.getFieldValue('consignment_status') || '',
        allowed_weightage: form.getFieldValue('allowed_weightage') || 0,
        quanitity: form.getFieldValue('quanitity') || 0,
        type: form.getFieldValue('type') || '',
        consignment_type: 'Import',
        custom_deck_no: form.getFieldValue('custom_deck_no') || '',
        pre_clearances_ids: form.getFieldValue('pre_clearances_ids') || [],
        product_registration_ids: form.getFieldValue('pr_registration_ids') || [],
        status: type === 'create' ? 'DRAFT' : status,
        site_visit: type === 'create' ? 'PENDING' : form.getFieldValue('site_visit') || 'PENDING',
        container_type: form.getFieldValue('container_type') || '',
        product_reg_type: form.getFieldValue('product_reg_type') || null,
        import_lines:
          importPackingListLinesRef.current.length > 0
            ? importPackingListLinesRef.current
            : form.getFieldValue('import_lines') || [],
      };

      if (type === 'create') {
        storeImport(submissionData)
          .then((res: any) => {
            setLoading(false);
            navigate(`/view-import`, { state: { id: res?.data?.id } });
          })
          .catch((err: any) => {
            notificationController.error({ message: err.message });
            setLoading(false);
          });
      } else if (type === 'edit' && importId) {
        updateImport(importId, submissionData)
          .then(() => {
            setLoading(false);
            navigate(`/view-import`, { state: { id: id } });
          })
          .catch((err: any) => {
            notificationController.error({ message: `${err.message}` });
            setLoading(false);
          });
      }
    }
    console.log('Form Submitted');
  };
  const storedType = localStorage.getItem('importType');
  const importType = storedType ? storedType.toLowerCase().replace(/_/g, '-') : 'normal';

  useEffect(() => {
    //console.log({ canCreateFollowUp });
    const buttons = {
      'save-button': editable && (
        <BaseButton
          type="primary"
          loading={isLoading}
          size="small"
          onClick={() => {
            form
              .validateFields()
              .then((values) => {
                handleSubmit(values);
              })
              .catch((error) => {
                console.error('Validation failed:', error);
              });
          }}
        >
          {t('Save')}
        </BaseButton>
      ),
      'cancel-button': editable && (
        <BaseButton onClick={() => navigate(`/import/${importType}`)} size="small" style={{ marginRight: '8px' }}>
          {t('Cancel')}
        </BaseButton>
      ),
      'edit-button': type === 'view' && importId && editableUserType && (
        <BaseButton
          type="primary"
          onClick={() => navigate('/edit-import', { state: { id: id } })}
          size="small"
          style={{ marginRight: '8px' }}
        >
          {t('Edit')}
        </BaseButton>
      ),
      'follow-up-button': type === 'view' && importId && canCreateFollowUp && (
        <BaseButton
          type="primary"
          size="small"
          style={{ marginRight: '8px' }}
          // onClick={async () => {
          //   try {
          //     await createInitialFollowUp(importId);
          //   } catch (error) {
          //     console.error('Failed to create follow-up:', error);
          //     message.error(t('Failed to create follow-up.'));
          //   }
          // }}
          onClick={() => setFollowUpModalVisible(true)}
        >
          {t('Follow Up')}
        </BaseButton>
      ),
    };

    Object.entries(buttons).forEach(([key, button]) => {
      if (button) addHeaderButton(key, button);
    });

    return () => {
      Object.keys(buttons).forEach(removeHeaderButton);
    };
  }, [
    type,
    importId,
    editable,
    addHeaderButton,
    removeHeaderButton,
    t,
    navigate,
    isLoading,
    form,
    handleSubmit,
    id,
    importDetails,
    setActiveTab,
    canCreateFollowUp,
  ]);

  return (
    <>
      <BaseRow gutter={[16, 16]}>
        <BaseCol span={24}>
          <StatusBar
            id={id ?? null}
            status={status}
            setStatus={setStatus}
            wfActions={wfActions || []}
            currentType={type}
            workflowType={'import'}
            onViewInvoicesClick={() => setActiveTab('8')}
          />
        </BaseCol>

        <BaseCol span={24}>
          <BaseCard id="ImportForm" title={pageTitle} padding="1.25rem">
            {/* {user?.usertype !== 'CUSTOMER' && type === 'create' && customerSearchable && (
              <BaseCol span={12}>
                <Search enterButton="Search" size="small" onSearch={(e: any) => getCustomerData(e)} />
              </BaseCol>
            )} */}

            <BaseRow>
              <BaseCol span={24}>
                <Form
                  form={form}
                  name="ImportForm"
                  onFinish={handleSubmit}
                  labelCol={{ lg: { span: 6 }, md: { span: 6 }, sm: { span: 24 } }}
                  labelAlign="left"
                  labelWrap
                  wrapperCol={{ lg: { span: 16 }, md: { span: 18 }, sm: { span: 24 } }}
                  size="small"
                >
                  <Tabs
                    items={type == 'create' ? items?.slice(0, 2) : items}
                    activeKey={activeTab}
                    onChange={(key) => setActiveTab(key)}
                  />
                </Form>
              </BaseCol>
              <BaseCol span={12}></BaseCol>
            </BaseRow>
          </BaseCard>
        </BaseCol>
      </BaseRow>
      <Modal
        title={t('Create Follow Up')}
        open={followUpModalVisible}
        onCancel={() => {
          setFollowUpModalVisible(false);

          setSelectedArrival(null);
          setSelectedProduct(null);
          setSelectedVariety([]);

          setArrivalProductOptions([]);
          setVarietyOptions([]);
        }}
        onOk={async () => {
          if (!selectedArrival || !selectedProduct || selectedVariety.length === 0) {
            message.warning(t('Please select an arrival, product, and variety.'));
            return;
          }
          setFollowUpLoading(true);
          try {
            const response = await createInitialFollowUp(importId, {
              arrival_line_id: selectedProduct,
              import_line_variety_ids: selectedVariety,
            });

            console.log('FOLLOW UP RESPONSE:', response);

            notificationController.success({
              message: t('Success'),
              description: response?.message || t('Follow-up created successfully!'),
            });

            setFollowUpModalVisible(false);
            setSelectedArrival(null);
            setSelectedProduct(null);
            setSelectedVariety([]);
            setVarietyOptions([]);
            setArrivalProductOptions([]);
            navigate(`/view-follow-up`, {
              state: {
                id: response?.data?.id,
                import_id: importId,
              },
            });
          } catch (error) {
            console.error('Failed to create follow-up:', error);
            message.error(t('Failed to create follow-up.'));
          } finally {
            setFollowUpLoading(false);
          }
        }}
        confirmLoading={followUpLoading}
        okText={t('Create')}
        cancelText={t('Cancel')}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '8px 0' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500 }}>{t('Arrival Line')}</label>

            <Select
              style={{ width: '100%' }}
              placeholder={t('Select an arrival line')}
              value={selectedArrival}
              onChange={async (value) => {
                console.log('Selected Arrival ID:', value);

                setSelectedArrival(value);

                // reset dependent dropdowns
                setSelectedProduct(null);
                setSelectedVariety([]);

                setArrivalProductOptions([]);
                setVarietyOptions([]);

                if (!importId) {
                  console.warn('Missing importId');
                  return;
                }

                setProductLoading(true);

                try {
                  const res = await getProductOptions(importId, value);

                  console.log('Product Options API Response:', res);

                  const options =
                    res?.map((item: any) => ({
                      value: item.id,
                      label: item.label,
                    })) ?? [];

                  console.log('Mapped Product Options:', options);

                  setArrivalProductOptions(options);
                } catch (error) {
                  console.error('Failed to fetch product options:', error);
                  message.error(t('Failed to load product options'));
                } finally {
                  setProductLoading(false);
                }
              }}
              options={Arrivals.map((arrival: any) => ({
                value: arrival.id,
                label: `${arrival.code ?? arrival.reference_code ?? `Arrival #${arrival.id}`} - ${dayjs(
                  arrival.date,
                ).format('YYYY-MM-DD')}`,
              }))}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500 }}>{t('Product')}</label>
            <Select
              style={{ width: '100%' }}
              placeholder={productLoading ? t('Loading products...') : t('Select a product')}
              value={selectedProduct}
              disabled={!selectedArrival || productLoading || arrivalProductOptions.length === 0}
              loading={productLoading}
              onChange={async (value) => {
                console.log('Selected Product ID:', value);

                setSelectedProduct(value);

                // reset variety dropdown
                setSelectedVariety([]);
                setVarietyOptions([]);

                if (!importId || !selectedArrival) {
                  console.warn('Missing importId or selectedArrival');
                  return;
                }

                setVarietyLoading(true);

                try {
                  // value = selected product id
                  const res = await getVarietyOptions(importId, selectedArrival, value);

                  console.log('Variety Options API Response:', res);

                  const options =
                    res?.map((item: any) => ({
                      value: item.id,
                      label: item.label ?? item.name,
                    })) ?? [];

                  console.log('Mapped Variety Options:', options);

                  setVarietyOptions(options);
                } catch (error) {
                  console.error('Failed to fetch variety options:', error);
                  message.error(t('Failed to load variety options'));
                } finally {
                  setVarietyLoading(false);
                }
              }}
              options={arrivalProductOptions}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500 }}>{t('Variety')}</label>

            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder={varietyLoading ? t('Loading varieties...') : t('Select varieties')}
              value={selectedVariety}
              disabled={!selectedProduct || varietyLoading || varietyOptions.length === 0}
              loading={varietyLoading}
              onChange={(values) => {
                console.log('Selected Variety IDs:', values);

                const selectedOptions = varietyOptions.filter((v: any) => values.includes(v.value));

                console.log('Selected Variety Options:', selectedOptions);

                setSelectedVariety(values);
              }}
              options={varietyOptions}
            />
          </div>
        </div>
      </Modal>
      {/* <BaseRow>
        <BaseCol
          xs={24}
          lg={8}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            justifyContent: 'flex-end',
            marginLeft: 'auto',
            marginRight: 0,
          }}
        >
          <br />
          <h2 style={{ color: '#333B69', fontWeight: 'bold' }}>Job Info</h2>
          <div
            style={{
              padding: '1rem',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              backgroundColor: '#fff',
              width: '100%',
              marginTop: '-10px',
            }}
          >
            <div style={{ marginLeft: '1rem' }}>
              <div>
                <p style={{ color: '#B1B1B1' }}>Category:</p>
                <p style={{ margin: 0, color: '#C5C5CF' }}>{importDetails.job_id}</p>
              </div>

              <div>
                <p style={{ color: '#B1B1B1' }}>Job Type:</p>
                <Select
                  size="small"
                  style={{
                    width: '70%',
                    fontSize: '12px',
                  }}
                  disabled
                  value={importDetails.job_type}
                  options={typeOptions.map((option) => ({
                    label: option.label,
                    value: option.value,
                  }))}
                />
              </div>

              <div>
                <p style={{ color: '#B1B1B1' }}>Status:</p>
                <p style={{ margin: 0, color: '#C5C5CF' }}>{importDetails.status}</p>
              </div>
              <div>
                <p style={{ color: '#B1B1B1' }}>Expiration Countdown:</p>
                <p style={{ margin: 0, color: '#C5C5CF' }}>{importDetails.Expiration_Countdown}</p>
              </div>
            </div>
          </div>
        </BaseCol>
      </BaseRow> */}
    </>
  );
};

export default ImportForm;
